<template>
  <b-modal
    id="upload-video-modal"
    :title="trans('upload')"
    :ok-title="trans('upload')"
    :cancel-title="trans('cancel')"
    size="xl"
    @ok="onUpload"
    @show="onShow"
  >
    <b-row>
      <b-col>
        <p>
          {{ trans('upload_video_about') }}
        </p>
        <b-form-group>
          <b-form-file
            v-model="upload_file"
            :placeholder="trans('upload_video')"
            :drop-placeholder="trans('drop_file_here')"
            accept="video/*"
            :disabled="busy"
          />
        </b-form-group>
        <p v-if="upload_file && !fileTooBig">
          {{ numeral(fileSizeMb).format('1,000.0') }} {{ trans('mb') }}
        </p>
        <p v-if="upload_file && fileTooBig" class="text-danger">
          {{ numeral(fileSizeMb).format('1,000.0') }} {{ trans('mb') }}
          <br/>
          {{ trans('file_too_big')}}
        </p>
      </b-col>

      <b-col class="mt-2">
        <b-form-group :label="trans('name')">
          <b-form-input v-model="name" :disabled="busy" />
        </b-form-group>

        <b-form-group :label="trans('description')">
          <b-form-textarea v-model="description" :disabled="busy" />
        </b-form-group>

        <b-form-group :label="trans('date_of_recording')">
          <datetime v-model="recorded_at" :config="dateOptions" :disabled="busy" />
        </b-form-group>

        <b-form-group :label="trans('clip_video')">
          <b-row>
            <b-col>
              <b-form-input type="number" min="0" max="23" v-model="hour" :placeholder="trans('hour')" />
            </b-col>
            <b-col>
              <b-form-input type="number" min="0" max="59" v-model="minute" :placeholder="trans('minute')" />
            </b-col>
            <b-col>
              <b-form-input type="number" min="0" max="59" v-model="second" :placeholder="trans('second')" />
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group :label="trans('watermark')">
          <b-form-checkbox switch v-model="watermark" :disabled="busy">
            {{ trans('watermark_about') }}
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="organization.can_publish">
          <b-form-checkbox
            v-model="publish_to_partner"
            :value="organization.partner"
            :unchecked-value="null"
            :disabled="busy"
          >
            {{ trans('published_to_partner').replace(':partner', organization.partner) }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <p class="lead" v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      <span v-if="upload_percent == null">
        {{ trans('please_wait') }}
      </span>
      <span v-if="upload_percent !== null && upload_percent < 100">
        {{ trans('uploading') }}
        {{ upload_percent }}%
      </span>
      <span v-if="upload_percent == 100">
        {{ trans('generating_preview_thumbnail') }}
      </span>
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import Datetime from 'vue-bootstrap-datetimepicker'

  export default {
    props: {
      organization: Object,
    },
    components: {
      Datetime,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        busy: false,
        error: null,
        name: null,
        description: null,
        hour: null,
        minute: null,
        second: null,
        watermark: false,
        recorded_at: null,
        dateOptions: {
          locale: window.lang,
          format: 'LLL',
          showClear: true,
        },
        upload_file: null,
        upload_url: null,
        upload_percent: null,
        items: null,
        selected: null,
        pageCount: 1,
        pageSize: 4,
        nextPageToken: null,
        totalRows: null,
        publish_to_partner: null,
      }
    },
    computed: {
      clip() {
        return parseInt(this.hour||0, 10) * 3600 +
          parseInt(this.minute||0, 10) * 60 +
          parseInt(this.second||0, 10)
      },
      fileSizeMb() {
        return this.upload_file ? this.upload_file.size/1024/1024 : null
      },
      fileTooBig() {
        return this.upload_file.size/1024/1024 > 500
      },
    },
    watch: {
      selected() {
        if (this.selected) {
          let m = moment().startOf('day').seconds(this.selected.video.duration)
          this.hour = m.hour(); if (this.hour == 0) this.hour = 0
          this.minute = m.minute(); if (this.minute == 0) this.minute = null
          this.second = m.second();
          this.name = this.selected.name
          this.recorded_at = moment(this.selected.start).format('LLL')
          this.upload_url = this.selected.video.download_url
        }
      },
    },
    methods: {
      onShow() {
        this.name = null
        this.description = null
        this.hour = null
        this.minute = null
        this.second = null
        this.recorded_at = null
        this.upload_file = null;
        this.upload_url = null;
        this.upload_percent = null,
        this.busy = false
        this.error = null
        this.items = null
        this.pageCount = 1
        this.totalRows = null
        this.nextPageToken = null
        this.selected = null
        this.upload_url = null
        this.publish_to_partner = null
      },
      onUpload(e) {
        e.preventDefault();
        const url = `/organization/${this.organization.id}/media/video`
        this.busy = true
        this.error = null

        if (!this.upload_file) {
          this.busy = false
          this.error = trans('please_select_file')
          return
        }

        if (this.fileTooBig) {
          this.busy = false
          this.error = trans('video_too_big')
          return
        }

        let formData = this.buildFormData()
        formData.append('file', this.upload_file);

        axios.post(url, formData, {
          headers: {'Content-Type': 'multipart/form-data'},
          onUploadProgress: e => {
            this.upload_percent = Math.round((e.loaded * 100) / e.total)
          },
        })
        .then(response => {
          this.upload_url = response.data.url
          this.upload_percent = 100
          this.busy = false
          this.$bvModal.hide('upload-video-modal')
          this.$nextTick(() => {
            this.$emit('uploaded', response.data)
          })
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      buildFormData() {
        let formData = new FormData();
        formData.append('watermark', this.watermark ? 1 : 0)
        formData.append('clip', this.clip ? this.clip : 0)
        if (this.name) formData.append('name', this.name)
        if (this.description) formData.append('description', this.description)
        if (this.recorded_at) formData.append('recorded_at', moment(this.recorded_at, 'LLL').toISOString())
        if (this.organization.can_publish && this.publish_to_partner)
          formData.append('publish_to_partner', this.organization.partner)
        return formData
      },
    },
    mounted() {
      window.uploadVideoModal = this
    },
  }
</script>